/* eslint-disable max-len */
import React from 'react';

type Props = {
  width?: number;
  height?: number;
};

const Flag = ({ width = 20, height = 20 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.99951 10.8002V2L16.2217 5.20007L9.99951 8.40013'
        stroke='#FFFFFF'
        stroke-linecap='round'
        stroke-linejoin='round'
      />

      <path
        d='M16.6583 8.57779C17.0722 9.88993 17.1109 11.2968 16.7699 12.6309C16.4288 13.965 15.7224 15.1703 14.7345 16.1033C13.7467 17.0363 12.5191 17.6578 11.1977 17.8938C9.87636 18.1299 8.5169 17.9705 7.28107 17.4347C6.04525 16.8989 4.98507 16.0092 4.22669 14.8714C3.4683 13.7337 3.04362 12.3958 3.00318 11.017C2.96274 9.63814 3.30824 8.27636 3.99858 7.09367C4.68891 5.91098 5.69502 4.95717 6.8972 4.3457'
        stroke='#FFFFFF'
        stroke-linecap='round'
        stroke-linejoin='round'
      />

      <path
        d='M6.88998 8.39746C6.50024 8.93109 6.24651 9.55655 6.15191 10.2169C6.0573 10.8772 6.12483 11.5513 6.34834 12.1779C6.57185 12.8045 6.94424 13.3636 7.43157 13.8043C7.91891 14.2449 8.5057 14.5532 9.13849 14.7009C9.77127 14.8487 10.4299 14.8312 11.0545 14.6501C11.679 14.469 12.2496 14.13 12.7142 13.664C13.1787 13.1981 13.5226 12.62 13.7144 11.9824C13.9062 11.3447 13.9398 10.6679 13.8122 10.0135'
        stroke='#FFFFFF'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default Flag;
